// extracted by mini-css-extract-plugin
export var fullGrid = "_2k-3";
export var pdpPreviewContainer = "_2k-1";
export var previewContainer = "_2k-0";
export var togglePreviewContainer = "_2k-2";